import React from "react";
import { STATUS_OPTIONS } from "./orderModalCenter.constants";

export function Row({ k, v }) {
    return (
        <div className="ao-rowline">
            <div className="ao-rowline__k">{k}</div>
            <div className="ao-rowline__v">{v || "—"}</div>
        </div>
    );
}

export function getId(value) {
    if (!value) return "";

    if (typeof value === "object") {
        return value._id || value.id || "";
    }

    return String(value);
}

export function getOrderId(order = {}) {
    return order?._id || order?.id || "";
}

export function getOfficeId(order = {}) {
    const office = order?.officeId;

    if (!office) return "";

    if (typeof office === "object") {
        return office._id || office.id || "";
    }

    return String(office);
}

export function getLabel(value, keys = []) {
    if (!value) return "—";

    if (typeof value !== "object") return String(value);

    for (const key of keys) {
        if (value[key]) return value[key];
    }

    return value.name || value.title || value.method || value.service || value.address || value._id || "—";
}

export function optionLabel(option) {
    return (
        option?.name ||
        option?.title ||
        option?.method ||
        option?.service ||
        option?.address ||
        option?.label ||
        option?._id ||
        "Без названия"
    );
}

export function formatDate(value) {
    if (!value) return "—";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return "—";

    return date.toLocaleString("ru-RU");
}

export function formatMoney(value) {
    const num = Number(value || 0);

    if (!Number.isFinite(num)) return "0 ₽";

    return `${num.toLocaleString("ru-RU")} ₽`;
}

export function normalizePicture(value) {
    if (!value) return "";

    if (typeof value === "string") return value;

    return value.img || value.url || value.path || value.src || value.filename || "";
}

export function filterOrderStatusColor(textOrType) {
    switch (textOrType) {
        case "ordered":
        case "Оформлен":
        case "Оформлена":
            return "gray";

        case "confirmed":
        case "Подтвержден оператором":
        case "Подтверждён оператором":
            return "green";

        case "work":
        case "Производство":
        case "На рассмотрении":
            return "greenDark";

        case "shipped":
        case "Передан в службу доставки":
            return "blue";

        case "delivered":
        case "Доставлен":
            return "gold";

        case "declined":
        case "Отклонено":
            return "red";

        default:
            return "green";
    }
}

export function getStatusList(orderDetails) {
    const savedStatuses = Array.isArray(orderDetails?.orderStatus)
        ? orderDetails.orderStatus
        : [];

    return STATUS_OPTIONS.map((statusOption) => {
        const saved = savedStatuses.find((item) => item?.type === statusOption.type);

        return {
            ...statusOption,
            _id: saved?._id,
            date: saved?.date || null,
            isCompleted: !!saved?.isCompleted,
            savedText: saved?.text || statusOption.text,
        };
    });
}

export function getLatestCompletedStatus(statuses = []) {
    const completed = statuses
        .filter((item) => item?.isCompleted)
        .sort((a, b) => {
            const aTime = a?.date ? new Date(a.date).getTime() : 0;
            const bTime = b?.date ? new Date(b.date).getTime() : 0;

            return bTime - aTime;
        });

    return completed[0] || statuses.find((item) => item?.type === "ordered") || null;
}

export function getPaymentTotal(paymentAccounts = []) {
    return paymentAccounts.reduce((sum, item) => {
        const price = Number(item?.price || 0);

        return Number.isFinite(price) ? sum + price : sum;
    }, 0);
}

export function getPaymentState(totalAmount, paidAmount) {
    const total = Number(totalAmount || 0);
    const paid = Number(paidAmount || 0);

    if (!total) {
        return {
            label: "Сумма заказа не указана",
            color: "muted",
            percent: 0,
            left: 0,
        };
    }

    const percent = Math.min(100, Math.round((paid / total) * 100));
    const left = Math.max(0, total - paid);

    if (paid <= 0) {
        return {
            label: "Оплаты ещё не было",
            color: "danger",
            percent,
            left,
        };
    }

    if (paid < total) {
        return {
            label: "Частичная оплата",
            color: "warning",
            percent,
            left,
        };
    }

    if (paid === total) {
        return {
            label: "Оплачено полностью",
            color: "success",
            percent: 100,
            left: 0,
        };
    }

    return {
        label: "Оплачено с переплатой",
        color: "success",
        percent: 100,
        left: 0,
    };
}
